module.exports = __webpack_public_path__ + "img/40_38_034_370.a3a00de1.jpg";